import { JOGGResponse } from "@jog/types"

import { JoggApiOption } from "./client"

export const voucherRemoveBase = ({ execute, setToken }: Pick<JoggApiOption, "execute" | "setToken">) => {
    return async (voucherCode: string, cartId: string): Promise<JOGGResponse<{ cart: { id: string } }>> => {
        const requestWithToken = await setToken({
            uri: `/ctp/carts/${cartId}/removeVoucher`,
            method: "POST",
            body: {
                voucherCode,
            },
        })
        return execute(requestWithToken)
    }
}
